import React from "react";
import { Navigate } from "react-router-dom";
import SalesAffiliateLayout from "../components/SalesAffiliateLayout";
import SalesAffiliateCommissionExperience from "../components/SalesAffiliateCommissionExperience";
import { useSalesAffiliateWorkspace } from "../context/SalesAffiliateWorkspaceContext";
export default function SalesAffiliateEarnings() {
  const { loading, workspaceData: status, configuration, lifecycleState } = useSalesAffiliateWorkspace();
  if(loading) return <SalesAffiliateLayout activeSection="earnings"><div className="p-10">Loading earnings…</div></SalesAffiliateLayout>;
  if(!configuration.allowsDashboardPage||!status?.affiliate_exists) return <Navigate to={configuration.defaultPath} replace/>;
  return <SalesAffiliateLayout activeSection="earnings" lifecycleState={lifecycleState}><main className="mx-auto max-w-7xl px-6 py-8 sm:px-8"><SalesAffiliateCommissionExperience requirements={status?.requirements||[]}/></main></SalesAffiliateLayout>;
}
